class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static filterFacetBrandItem() {
    let brandFilterSearch = document.querySelector(".js-brand-filter"),
      brandFilterItemsContainer = document.querySelector(".brand-filter-items"),
      readMore = brandFilterItemsContainer?.querySelector('read-more');

    if (!brandFilterSearch) return;
    brandFilterSearch.addEventListener("input", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const searchValue = event.target.value.toLowerCase();

      Array.from(
        brandFilterItemsContainer.querySelectorAll(
          ".facet-checkbox__text-label",
        ),
      ).forEach((item) => {
        item.parentNode.parentNode.parentNode.classList.remove("hide-filter");
      });

      Array.from(
        brandFilterItemsContainer.querySelectorAll(
          ".facet-checkbox__text-label",
        ),
      ).forEach((item) => {
        const itemText = item.textContent.toLowerCase();

        if (FacetFiltersForm.testBrandOnQuery(itemText, searchValue)) {
          item.parentNode.parentNode.parentNode.classList.remove("hide-filter");
        } else {
          item.parentNode.parentNode.parentNode.classList.add("hide-filter");
        }
      });

      readMore?.init()
    });
  }

  static testBrandOnQuery( string, query ) { 
    if (string === query || string?.includes(query)) return true; 
    let queryCharIndex = 0;
    for (let i = 0; i < string.length; i++) {
      if (string[i] === query[queryCharIndex]) {
        queryCharIndex++;
      } 
      if (queryCharIndex === query.length) {
        return true;
      }
    }

    return false;
  }

  static priceRangeChange() {
    const minSlider = document.getElementById("min-slider");
    const maxSlider = document.getElementById("max-slider");
    const sliderRange = document.getElementById("slider-range");
    const priceRange = document.getElementById("price-range");
    const minInput = document.getElementById("Filter-Price-GTE");
    const maxInput = document.getElementById("Filter-Price-LTE");

    if (!minSlider || !maxSlider || !sliderRange || !priceRange || !minInput || !maxInput) {
      return;
    }

    function updateSlider() {
      let minVal = parseFloat(minSlider.value);
      let maxVal = parseFloat(maxSlider.value);

      const minAllowed = parseFloat(minSlider.min) || 0;
      const maxAllowed = parseFloat(maxSlider.max);

      // Guard against invalid / NaN values coming from malformed inputs
      if (isNaN(minVal)) minVal = minAllowed;
      if (isNaN(maxVal)) maxVal = maxAllowed;

      // Clamp within allowed bounds
      if (minVal < minAllowed) minVal = minAllowed;
      if (maxVal > maxAllowed) maxVal = maxAllowed;

      // Ensure min never exceeds max
      if (minVal > maxVal) {
        minVal = maxVal;
      }

      minSlider.value = minVal;
      maxSlider.value = maxVal;

      const percentMin = (minVal / minSlider.max) * 100;
      const percentMax = (maxVal / maxSlider.max) * 100;

      sliderRange.style.left = percentMin + "%";
      sliderRange.style.width = percentMax - percentMin + "%";

      priceRange.innerText =
        "€" + minVal.toFixed(2) + " - €" + maxVal.toFixed(2);

      minInput.value = minVal.toFixed(2);
      maxInput.value = maxVal.toFixed(2);
    }

    minSlider.addEventListener("input", updateSlider);
    maxSlider.addEventListener("input", updateSlider);

    minInput.addEventListener("input", function () {
      minSlider.value = parseFloat(minInput.value);
      updateSlider();
    });

    maxInput.addEventListener("input", function () {
      maxSlider.value = parseFloat(maxInput.value);
      updateSlider();
    });

    updateSlider();
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    FacetFiltersForm.filterFacetBrandItem();
    FacetFiltersForm.priceRangeChange();
    document.getElementById("ProductGridContainer").scrollIntoView();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const parseHtml = new DOMParser().parseFromString(html, "text/html");

    const mobFilterTrigger = parseHtml.querySelector("filter-mobile");
    const currentFilterMobile = document.querySelector("filter-mobile");
    if (currentFilterMobile && mobFilterTrigger) {
      currentFilterMobile.innerHTML = mobFilterTrigger.innerHTML;
    }

    const mobApplyBtn = parseHtml.querySelector(".apply-filter-btn");
    const currentApplyBtn = document.querySelector(".apply-filter-btn");
    if (currentApplyBtn && mobApplyBtn) {
      currentApplyBtn.innerHTML = mobApplyBtn.innerHTML;
    }

    const count = parseHtml.getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id,
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element),
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId,
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter"),
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID),
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details",
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden"),
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item"),
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    // Avoid sending default price values as active filters
    try {
      const minSlider = form.querySelector("#min-slider");
      const maxSlider = form.querySelector("#max-slider");
      const minInput = form.querySelector("#Filter-Price-GTE");
      const maxInput = form.querySelector("#Filter-Price-LTE");

      if (minSlider && maxSlider && minInput && maxInput) {
        const sliderMin = parseFloat(minSlider.min) || 0;
        const sliderMax = parseFloat(maxSlider.max);
        const currentMin = parseFloat(minInput.value);
        const currentMax = parseFloat(maxInput.value);

        // If the current values match the default slider bounds, treat as "no price filter"
        if (isNaN(currentMin) || currentMin <= sliderMin) {
          formData.delete("filter.v.price.gte");
        }

        if (isNaN(currentMax) || currentMax >= sliderMax) {
          formData.delete("filter.v.price.lte");
        }
      }
    } catch (e) {
      // Fail silently – we don't want price logic to break other filters
    }

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (event.target.classList.contains('js-filter-search')) return
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.filterFacetBrandItem();
FacetFiltersForm.priceRangeChange();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

// Filter mobile trigger
class FilterMobile extends HTMLElement {
  constructor() {
    super();

    this.scrollPosition = 0;
  }

  connectedCallback() {
    this.filterButton = document.querySelector(".filter-mobile-btn");
    this.asideElement =
      document.querySelector("#main-collection-filters") ||
      document.querySelector("#main-search-filters");
    this.closeFilters = document.querySelector(".close-aside");
    this.asideOverlay = document.querySelector(".aside-overlay");
    this.applyBtn = document.querySelector(".apply-filter-btn");

    this.filterButton.addEventListener("click", this.openAside.bind(this));
    this.asideOverlay.addEventListener("click", this.closeAside.bind(this));
    this.closeFilters.addEventListener("click", this.closeAside.bind(this));
    this.applyBtn.addEventListener("click", this.closeAside.bind(this));
  }

  openAside(event) {
    event.preventDefault();
    this.scrollPosition = window.scrollY;
    this.asideElement.classList.add("open-filter");
    document.documentElement.classList.add("overflow-hidden");
    this.asideOverlay.classList.add("!block");
  }

  closeAside(event) {
    event.preventDefault();
    this.asideElement.classList.remove("open-filter");
    document.documentElement.classList.remove("overflow-hidden");
    this.asideOverlay.classList.remove("!block");
  }
}

customElements.define("filter-mobile", FilterMobile);
